module.exports = __webpack_public_path__ + "img/aboservice-v1-v2.b14686c1.jpg";